import React from "react";
import { Container, Title } from "./PortfolioStyles";
import Footer from "../../components/Footer";
import construcao from "../../images/construcao.png";

const Portfolio = () => {
  return (
    <>
      <Container>
        <Title></Title>
        <img src={construcao} alt="Em construção" />
      </Container>
      <Footer />
    </>
  );
};

export default Portfolio;
